import { render } from "./HeaderFramework.vue?vue&type=template&id=7d2e5a45"
import script from "./HeaderFramework.vue?vue&type=script&lang=js"
export * from "./HeaderFramework.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/beatentodeath/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__